import React, { useState, useEffect } from "react";
import AssetTypeLabel from "./AssetTypeLabel.jsx";
import { getPluralForm, ignoreResourceLibraryWord } from "../../../utils/plural"
import { getMenu, getSearch } from "./api.js";
import Listbox from "./Listbox-2.jsx";

/**
 * {
    "categories": [
        "Library",
        "Engine",
        "Detroit",
        "DD13",
        "Videos"
    ],
    "file": "https://dtnacontent-dtna-stg.qa.freightliner.com/content/dam/enterprise/videos/1409-detroit_connect-texmix_virtual-2017-04-10.mp4",
    "jwPlayerCode": null,
    "id": 1409,
    "thumb": "https://dtnacontent-dtna-stg.qa.freightliner.com/content/dam/enterprise/thumb/videos/TexMixThumb.jpg",
    "title": "Detroit Connect - TexMix Virtual Technician Testimonial Video",
    "type": "VID",
    "videoTime": "1:39"
}
 */

const assetsDefault = { items: [], total: 0 };



function getItemTitle(item) {
	
	if (!item)
		return '';

	if (ignoreResourceLibraryWord(item.name))
		return item.name;
	/*
	if (item.parent?.id === 1)
		return getPluralForm(item.name);
	*/

	return item.name;
}

function SearchMenu({
	linkList = [],
	menuItems,
	tileHandler,
	setSecondaryMenu = (menu = []) => { },
	setTertiaryMenu = (menu = []) => { },
	setActiveMenu = (menuItem = {}) => { },
	setUrlPath = (menuItem = {}) => { },
	createAllMenuItem = (menuItem = {}) => { }
}) {


	return (
		// Cards Area
		<div className="tw-hidden lg:tw-grid tw-grid-cols-3 tw-gap-12 ">
			{menuItems.map((item) => (
				<div
					key={item.id}
					className="tw-cursor-pointer tw-bg-[#6f87a6] tw-border-0 tw-rounded-2 tw-shadow-inset-0 tw-text-white tw-inline-block tw-min-w-[230px] tw-px-20 tw-py-10 tw-text-center tw-no-underline hover:tw-shadow-.25s hover:tw-bg-[#713738]"
					onClick={() => {tileHandler(item)}}
				>
					{item.name}
				</div>
			))}
		</div>
	);


}

function SearchMenuIndex({
	isMobile = false,
	linkList = [],
	menuItems,
	tileHandler,
	setSecondaryMenu = (menu = []) => { },
	setTertiaryMenu = (menu = []) => { },
	setActiveMenu = (menuItem = {}) => { },
	setUrlPath = (menuItem = {}) => { },
	createAllMenuItem = (menuItem = {}) => { }
}) {	
	return (
		<>
			{isMobile
				? (


					<div>

					<SearchMenuMobile
					linkList={linkList}
					setSecondaryMenu={setSecondaryMenu}
					setTertiaryMenu={setTertiaryMenu}
					setActiveMenu={setActiveMenu}
					setUrlPath={setUrlPath}
						createAllMenuItem={createAllMenuItem} />

					<Listbox
						label="Order By"
						selectList={orderByList}
						selected={orderBy}
						setSelected={setOrderBy} />
					</div>


				)
				: (<SearchMenu
					menuItems={menuItems}
					linkList={linkList}
					tileHandler={tileHandler}
					setSecondaryMenu={setSecondaryMenu}
					setTertiaryMenu={setTertiaryMenu}
					setActiveMenu={setActiveMenu}
					setUrlPath={setUrlPath}
					createAllMenuItem={createAllMenuItem} />)}
		</>
	);
}

function SearchMenuMobile({
	linkList = [],
	visibleHandler,
	setSecondaryMenu = (menu = []) => { },
	setTertiaryMenu = (menu = []) => { },
	setActiveMenu = (menuItem = {}) => { },
	setUrlPath = (menuItem = {}) => { },
	createAllMenuItem = (menuItem = {}) => { }
}) {
	
	const tabs = (function () {

		const accordionTabs = [];
		let accordionElements = undefined;

		function getAccordionElements() {

			if (accordionElements === undefined) {

				accordionElements = {};

				for (let i = 0, l = accordionTabs.length; i < l; i++) {

					const element = document.getElementById(`tab-${accordionTabs[i]}`);

					if (element) {

						const buttons = element.getElementsByClassName('accordion__dropdown-button');
						if (!buttons || buttons.length === 0)
							alert(`Accordion button for id ${accordionTabs[i]} has not been formatted correctly`);

						const bodies = element.getElementsByClassName('accordion__body');
						if (!bodies || bodies.length === 0)
							alert(`Accordion body for id ${accordionTabs[i]} has not been formatted correctly`);

						accordionElements[accordionTabs[i]] = {
							body: bodies[0],
							button: buttons[0],
							id: accordionTabs[i]
						}
                    }
				}
            }

			return accordionElements;
		}

		function toggle(id) {

			const accordions = getAccordionElements();

			if (!accordions[id])
				alert(`An accordion for id ${id} doesn't exist`);

			for (let i in accordions) {

				if (accordions[i].id === id) 
					toggleAccordion(accordions[i])
				else 
					toggleAccordion(accordions[i], true);
                
            }
		}

		function toggleAccordion(accordion, close) {

			if (close) {
				accordion.button.classList.remove('collapse');
				accordion.body.classList.remove('show');
			} else {
				accordion.button.classList.toggle('collapse');
				accordion.body.classList.toggle('show');
            }
        }

		return {
			add: (id) => { accordionTabs.push(id); },
			toggle
		};

	})();
	
	return (
		<div className="specs-accordion-group tw-border-0 tw-border-t tw-border-[#ccc] tw-border-solid">
			{linkList.map((item) => {

				tabs.add(item.id);

				const _elementId = `tab-${item.id}`;

				const _allMenuItem = createAllMenuItem(item);

				return (
					<div
						id={_elementId}
						key={item.id}
						className="accordion"
						onClick={() => { tabs.toggle(item.id); }}>
						<div className="accordion__tab">
							<div className="accordion__title">{getItemTitle(item)}</div>
							<button
								className="accordion__dropdown-button"
								data-dropdown={item.id}>
								<i className="icon-down-arrow"></i>
							</button>
						</div>
						<div className="accordion__body tw-mt-0 !tw-pt-0" data-dropdown={item.id}>
							<div
								role="button"
								title={`Show ${_allMenuItem.name} assets SECOND LEVEL`}
								className="tw-text-secondary tw-my-4"
								onClick={() => {
									console.log('MOBILE THIRD LEVEL CLICKED');
									setActiveMenu(item);
									setUrlPath(item);
									// NEED TO UPDATE SETURLPATH TO WORK LIKE SETHISTORY
									/* setHistory(item, 'CATEGORY', 'DOWN'); */
									getMenu(item.id).then((d) => {
										if (d.length >= 1) {
											setTertiaryMenu(d);
										} else {
											_history.isAsset = true;
										}
									});
									// DZ - I THINK THIS IS WHERE YOU GET THE NEXT LEVEL DOWN WITH A LIVE API CALL TO MENU LIKE DESKTOP
									
									if (item?.children?.length) {
										setTertiaryMenu([createAllMenuItem(item), ...item.children]);
									}
									
								}}>
								{_allMenuItem.displayName}
							</div>
							{item.children.map((child) => {
								return (
									<div
										key={child.id}
										role="button"
										title={`Show ${child.name} assets THIRD LEVEL`}
										className="tw-text-secondary tw-my-4"
										onClick={() => {
											console.log('MOBILE SECOND LEVEL CLICKED');
											setSecondaryMenu([
												createAllMenuItem(item),
												...item.children,
											]);
											setActiveMenu(child);
											setUrlPath(child);
										}}>
										{child.name}
									</div>
								)
                            })}
						</div>
					</div>
				)}
			)}
		</div>
	)
}

function SearchResults({ results = [] }) {
	return results.map((result) => {
		return (
			<a key={result.id} className="tw-flex tw-gap-8 tw-ring-secondary hover:tw-ring-1 tw-text-text tw-py-px" href={result.file} target="_BLANK">
				<div className="tw-py-[10px]">
					<div className="tw-h-[150px] tw-aspect-square tw-flex tw-items-center tw-justify-center tw-bg-gray-50 tw-p-[20px]">
						{result.thumb ? (
							<img
								src={result.thumb}
								alt=""
								className="tw-w-auto tw-h-full tw-object-cover tw-drop-shadow-asset"
							/>
						) : (
							"No preview"
						)}
					</div>
				</div>
				<div className="tw-flex-1 tw-py-[10px] tw-border-0 tw-border-solid tw-border-gray-100 tw-border-b">
					<div className="tw-max-w-[235px] tw-leading-snug">{result.title}</div>
					<div className="tw-text-[12px] tw-font-light">
						{result.categories.filter((c) => c != "Library").join(" → ")}
					</div>
					<div>
						<AssetTypeLabel asset={result} />
					</div>
				</div>
			</a>
		);
	});
}

export default function Search({
	setSecondaryMenu = (menu = []) => {},
	setTertiaryMenu = (menu = []) => {},
	setActiveMenu = (menuItem = {}) => { },
	setUrlPath = (menuItem = {}) => { },
	activeFilters = [],
	menuItems,
	tileHandler,
	createAllMenuItem = (menuItem = {}) => { },
	placeHolder = 'Search',
	isMobile = false,
	visibleHandler,
	breadCrumb

}) {
	const [searchTerm, setSearchTerm] = useState("");
	const [linkList, setLinkList] = useState([]);
	const [assets, setAssets] = useState({ items: [] });
	const [currentOffset, setCurrentOffset] = useState(0);
	useEffect(() => {
		setCurrentOffset(0);
		setAssets(assetsDefault);
		
		if (!!searchTerm) {
			getSearch(searchTerm, {
				assetTypes: activeFilters.join(","),
				start: currentOffset,
			}).then((response) => {
				
				setAssets(response);
			});
		}
	}, [searchTerm, activeFilters.join(",")]);
	useEffect(() => {
		if (currentOffset === 0) return;
		getSearch(searchTerm, {
			start: currentOffset,
			assetTypes: activeFilters.join(","),
		}).then((response) => {			
			setAssets({ ...assets, items: [...assets.items, ...response.items] });
		});
	}, [currentOffset]);

	useEffect(() => {
		/* DZ - THIS IS HOW THE MIDDLE GETS POPULATED */
		getMenu().then((d) => {
			setLinkList(d);
		});
	}, []);

	return (
		<>
			{/* // for some reason there's a lot of !important on inputs in forms if they're not classed with `gsc-search-box`
					// but we still need to add ! to our tailwind classes, least now they'll win out... */}
			<form
				action=""
				onSubmit={(e) => {
					e.preventDefault();
					const searchTerm = e?.currentTarget?.assetSearch?.value;
					if (typeof searchTerm === "string") {
						setSearchTerm(searchTerm);
						visibleHandler(searchTerm);
					} 
				}}
				className="gsc-search-box tw-flex tw-items-center tw-bg-gray-50 tw-rounded tw-px-6 tw-ring-blue-200 focus-within:tw-ring-1 tw-mb-10"
			>
				<span
					role="button"
					className="icon-header-search tw-leading-none tw-top-1 tw-relative tw-text-gray-500"
				></span>
				<input
					type="text"
					placeholder={placeHolder}
					name="assetSearch"
					className="!tw-m-0  tw-h-[43px] !tw-bg-gray-50 tw-px-[5px] tw-py-[10px] !tw-border-0 focus:!tw-border-0 focus:!tw-shadow-none !tw-border-transparent focus:!tw-border-transparent !focus:tw-ring-0 !tw-outline-none focus:!tw-outline-none tw-w-full"
					id="assetSearch"
				/>
			</form>

			{searchTerm === "" ? (
				<SearchMenuIndex
					menuItems={menuItems}
					tileHandler={tileHandler}
					isMobile={isMobile}
					linkList={linkList}
					setSecondaryMenu={setSecondaryMenu}
					setTertiaryMenu={setTertiaryMenu}
					setActiveMenu={setActiveMenu}
					setUrlPath={setUrlPath}
					createAllMenuItem={createAllMenuItem} />
			) : (
				<div className="tw-font-sans">
					<div className="tw-flex">
						<p className="resource-library-menu-h2 tw-text-[14px] tw-font-normal tw-mb-0 tw-underline" onClick={() => {
							let e = document.getElementById("assetSearch");
							e.value = "";
							const searchTerm = "";
							setSearchTerm(searchTerm);
							visibleHandler(searchTerm);
						}}>All Topics</p> <p className={`tw-px-2 tw-mb-0`}>></p> <p className={`resource-library-menu-h2 tw-text-[14px] tw-font-normal tw-mb-0`}>Search Results</p>
					</div>
					{assets.total ? (
						<div className="tw-mt-10 tw-font-light tw-text-[14px]">
							1 - {assets.items.length} of {assets.total}
						</div>
					) : null}
						<SearchResults results={assets.items} />
						{assets.total > assets.items.length ? (
							<div className="tw-flex tw-justify-center tw-my-10">
								<button
									title="load more"
									onClick={(e) => {
										setCurrentOffset(currentOffset + 12);
										e.currentTarget.blur(); // removes the active state of button
									}}
								>
									Load more
								</button>
							</div>
						) : (
							assets.total === 0 && (
								<div className="tw-flex tw-justify-center tw-my-10">
									There were no assets related to your search.
								</div>
							)
						)}
					</div>
			)}
		</>
	);
}
